import { Button, Tooltip } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

export function CheckBox({
  label,
  info,
  checked,
  setChecked,
  disabled,
  size = "large",
  checkedColor = "success", // Default checkedColor
  ...props
}) {
  // Dynamic color assignment: checked uses checkedColor, unchecked always uses grey
  const themeColor = checked ? (checkedColor === "success" ? "success.main" : checkedColor) : "text.secondary"; // Always grey when unchecked

  return (
    <Tooltip placement="top" title={info}>
      <Button
        disabled={disabled}
        onClick={() => setChecked(!checked)}
        variant="outlined"
        size={size}
        startIcon={
          checked ? (
            <CheckBoxIcon sx={{ color: themeColor }} />
          ) : (
            <CheckBoxOutlineBlankIcon sx={{ color: "text.secondary" }} /> // Always grey for unchecked icon
          )
        }
        sx={{
          ...props.sx,
          color: themeColor, // Text and icon color
          border: `1px solid`, // Explicit border style
          borderColor: themeColor, // Dynamic border color
          "&:hover": {
            borderColor: themeColor, // Keep border color on hover
            backgroundColor: "transparent", // Prevent background on hover
          },
          "&.Mui-disabled": {
            color: "lightgrey",
            borderColor: "lightgrey", // Handle disabled state styles
          },
        }}
      >
        {label}
      </Button>
    </Tooltip>
  );
}
